import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/DateFromUnixTime';
import { AvailableErrorLogTypes } from '@/services/api/resources/sso-configuration/errorLogTypes';
import { meta } from '@/services/api';

export const oAuthConfigurationCodec = t.type({
  authorizationUri: t.string,
  tokenUri: t.string,
  userInfoUri: t.string,
  clientId: t.string,
  clientSecret: t.string,
  scope: t.string,
});

export type oAuthConfiguration = t.TypeOf<typeof oAuthConfigurationCodec>;

export const SamlConfigurationCodec = t.type({
  entityId: t.string,
  nameIdFormat: t.string,
  authorizationUri: t.string,
  singleSignOnService: t.string,
  singleLogoutService: t.string,
  certificate: t.union([t.string, t.unknown]),
});

export const ScimMappingCodec = t.type({
  id: t.number,
  schemaNamespace: t.string,
  groupAttribute: t.string,
});

export type SamlConfiguration = t.TypeOf<typeof SamlConfigurationCodec>;
export type ScimErrorLog = t.TypeOf<typeof ssoErrorLogCodec>;

export const ssoConfigurationCodec = t.type({
  organizationId: t.number,
  identityProviderType: t.string,
  jitProvisioning: t.boolean,
  scimEnabled: t.boolean,
  scimRoleMappingEnabled: t.boolean,
  scimAccessKey: t.union([t.null, t.string]),
  scimSchemaNamespace: t.union([t.null, t.string]),
  scimGroupAttribute: t.union([t.null, t.string]),
  emailDomains: t.array(t.string),
  defaultRole: t.union([t.null, t.number]),
  configuration: t.union([oAuthConfigurationCodec, SamlConfigurationCodec, t.null]),
});

export const ssoErrorLogCodec = t.type({
  createdAt: DateFromUnixTime,
  updatedAt: DateFromUnixTime,
  type: t.union([
    t.literal(AvailableErrorLogTypes.INVALID_ACCESS_KEY),
    t.literal(AvailableErrorLogTypes.GENERIC),
  ]),
  message: t.string,
});

export const ssoErrorLogListCodec = t.type({
  data: t.array(ssoErrorLogCodec),
  meta,
});

export const ssoConfigurationResponseCodec = t.type({
  data: ssoConfigurationCodec,
});
